import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { Routes } from '@xolv-mybrightlink/common';

export const RootEventHandler = (props: { children: React.ReactNode }) => {
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const redirectToLogin = () => navigate(Routes.login);
    const rootElem = ref.current;
    const authErrorEvent = 'auth-error';
    rootElem?.addEventListener(authErrorEvent, redirectToLogin);
    return () => rootElem?.removeEventListener(authErrorEvent, redirectToLogin);
  }, [navigate]);
  return (
    <div id='app-root' ref={ref}>
      {props.children}
    </div>
  );
};
